// Presentation selection only. Authentication and capabilities still belong to the
// existing route guards. Ambiguous devices retain the full web experience.
export const classifyPhoneExperience = ({ userAgent = '', platform = '', maxTouchPoints = 0, mobileHint, screenWidth = 0, screenHeight = 0 } = {}) => {
  if (/iPad|Tablet|PlayBook|Silk/i.test(userAgent)
    || (platform === 'MacIntel' && maxTouchPoints > 1)) return 'full';
  if (/iPhone|iPod/i.test(userAgent)) return 'iphone';
  const shortEdge = Math.min(Number(screenWidth), Number(screenHeight));
  if (/Android/i.test(userAgent) && /Mobile/i.test(userAgent)
    && mobileHint !== false && maxTouchPoints > 0 && shortEdge > 0 && shortEdge < 600) return 'android';
  return 'full';
};

let selectedExperience;
export const getPhoneExperience = () => {
  if (typeof window === 'undefined') return 'full';
  if (selectedExperience) return selectedExperience;
  const nav = window.navigator;
  const detected = classifyPhoneExperience({
    userAgent: nav.userAgent, platform: nav.platform, maxTouchPoints: nav.maxTouchPoints,
    mobileHint: nav.userAgentData?.mobile, screenWidth: window.screen.width, screenHeight: window.screen.height,
  });
  // Only a presentation enum is retained, never account or financial data.
  try {
    const saved = window.sessionStorage.getItem('vylo-phone-experience-v1');
    selectedExperience = ['full', 'iphone', 'android'].includes(saved) ? saved : detected;
    window.sessionStorage.setItem('vylo-phone-experience-v1', selectedExperience);
  } catch { selectedExperience = detected; }
  return selectedExperience;
};
export const isPhoneExperience = () => getPhoneExperience() !== 'full';

const phoneRoutes = {
  '/': '/m/home', '/dashboard': '/m/home', '/transactions': '/m/activity',
  '/budgets': '/m/spend', '/income': '/m/income', '/net-worth': '/m/net-worth',
  '/accounts': '/m/accounts', '/categories': '/m/categories', '/household': '/m/household',
  '/settings': '/m/settings', '/reports': '/m/reports', '/insights': '/m/insights', '/insights/debt': '/m/insights/debt',
};
const fullRoutes = Object.fromEntries(Object.entries(phoneRoutes).filter(([key]) => key !== '/').map(([key, value]) => [value, key]));
export const resolveExperiencePath = (pathname, phone) => {
  if (phone) return phoneRoutes[pathname] || pathname;
  if (pathname === '/m' || pathname === '/m/') return '/dashboard';
  if (!pathname.startsWith('/m/')) return pathname;
  if (fullRoutes[pathname]) return fullRoutes[pathname];
  if (pathname === '/m/more') return '/settings';
  if (pathname === '/m/review') return '/transactions';
  if (pathname === '/m/home/trends') return '/dashboard';
  if (pathname === '/m/spend/trends') return '/budgets';
  if (pathname.startsWith('/m/net-worth/')) return '/net-worth';
  return '/dashboard';
};
